import angular from 'angular';
import bindHtmlDirective from './bindHtmlDirective';

angular
	.module('sh.bindHtml', [])
	// same as ng-bind-html but without the need for $sce service
	// <div sh-bind-html="expression">
	.directive('shBindHtml', bindHtmlDirective);
